import Logo from '../../application/assets/images/Ufarmx Logo.png'

function LogoComponent() {
    return (
        <div>
            <img src={Logo} alt="Logo" />
        </div>
    )
}

export default LogoComponent